module.exports = __webpack_public_path__ + "assets/81e545270fa47a82c6722964830b3027.jpg";